export default "__VITE_ASSET__CE3v02PD__"